import script from "./parental.vue?vue&type=script&setup=true&lang=ts"
export * from "./parental.vue?vue&type=script&setup=true&lang=ts"

import "./parental.vue?vue&type=style&index=0&id=7d81c4a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d81c4a9"]])

export default __exports__